// Module 2 / Slice 9 — feature-flag admin screen.
// Q-MOD2-FF-OWNERSHIP locks Module 2 as the owner. Read-only list +
// tenant-override pill for v1; inline tenant-override editor lands in
// a follow-up commit (rolloutPercentage UI is Phase-4 carry per ADR 0009).

import { useQuery } from "@tanstack/react-query";
import { referenceApiClient } from "../../api/client";
import { useI18n } from "../../i18n/I18nContext";

export function FeatureFlagAdminScreen(): JSX.Element {
  const { t } = useI18n();
  const query = useQuery({
    queryKey: ["admin", "feature-flags"],
    queryFn: async () => {
      const response = await referenceApiClient.GET("/admin/feature-flags", {
        params: { query: { limit: 200 } },
      });
      if (!response.data) {
        throw new Error("admin_featureflags_fetch_failed");
      }
      return response.data;
    },
  });

  return (
    <div>
      <h1>{t("admin.featureflags.heading")}</h1>
      <p className="rc-help">{t("admin.featureflags.description")}</p>
      {query.isLoading && <p>{t("login.discovering")}</p>}
      {query.isError && (
        <p role="alert" style={{ color: "var(--rc-color-danger)" }}>
          {(query.error as Error).message}
        </p>
      )}
      {query.data && query.data.items && (
        <table className="rc-table">
          <thead>
            <tr>
              <th>{t("admin.featureflags.column.key")}</th>
              <th>{t("admin.featureflags.column.flagType")}</th>
              <th>{t("admin.featureflags.column.defaultValue")}</th>
              <th>{t("admin.featureflags.column.tenantOverride")}</th>
              <th>{t("admin.featureflags.column.archived")}</th>
            </tr>
          </thead>
          <tbody>
            {query.data.items.map((f) => (
              <tr key={f.key}>
                <td><code>{f.key}</code></td>
                <td>{f.flagType}</td>
                <td><code>{JSON.stringify(f.defaultValue)}</code></td>
                <td>
                  {f.hasTenantOverride ? (
                    <span className="rc-pill rc-pill--info">
                      {t("admin.featureflags.overridden")}
                    </span>
                  ) : (
                    "\u2014"
                  )}
                </td>
                <td>{f.archivedAt ? "\u2714" : "\u2014"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
